import ClientManagementModule from "@/modules/ClientManagement";

function ClientManagementPage() {
  return <ClientManagementModule />;
}

export default ClientManagementPage;
